@if(show === true){
<div role="alert"
    [ngClass]="{'toast-main': alertFlashName === alertFlashNameConst.main, 'toast-dialog': alertFlashName !== alertFlashNameConst.main}"
    class="alert toast-main toast-alert alert-sm alert-dismissible fade in" [class]="alertClass">
    <button type="button" class="close" (click)="close()">
        <span class="vismaicon vismaicon-close">Close</span>
    </button>
    <div>
        <span>{{text}}</span>
    </div>
</div>
}